export default __webpack_public_path__ + "static/media/Version (4) - Half-Blood Prince_16.7d7f0b93.jpg";